(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('[data-hs-content]');
  var tocList = document.querySelector('.hs-article__l-list');
  if (!content || !tocList) return;

  var headings = content.querySelectorAll('h2, h3');
  if (!headings.length) {
    return;
  }

  var headingIdMap = new Map();

  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = 'heading-' + (index + 1);
    }

    var li = document.createElement('li');
    li.className = 'hs-article__l-item hs-article__l-item--' + heading.tagName.toLowerCase();

    var a = document.createElement('a');
    a.className = 'hs-article__l-link';
    a.href = '#' + heading.id;
    a.textContent = heading.textContent.trim();

    li.appendChild(a);
    tocList.appendChild(li);

    headingIdMap.set(heading, a);
  });

  if ('IntersectionObserver' in window) {
    var activeLink = null;

    function setActive(link) {
      if (!link || link === activeLink) return;
      // 先清干净，避免残留
      tocList.querySelectorAll('.hs-article__l-item.active')
        .forEach(function (el) { el.classList.remove('active'); });

      var item = link.closest('.hs-article__l-item');
      if (item) item.classList.add('active');
      activeLink = link;
    }

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
      if (!visible.length) return;

      setActive(headingIdMap.get(visible[0].target));
    }, { root: null, rootMargin: '0px 0px -80% 0px', threshold: 0.1 });

    headings.forEach(function (h) { observer.observe(h); });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    const cartRoot = document.querySelector('[data-hs-cart-form-box]');
    if (cartRoot) {
      document.dispatchEvent(new CustomEvent('hs:init:cart', { detail: { root: cartRoot } }));  
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var filterButton = document.querySelector('.hs-collection__filter');
  var filterDom = document.querySelector('#hs-collection-filter')
  let filterHtml = '';
  if (filterDom) {
    filterHtml = filterDom.innerHTML;
  }
  filterButton.addEventListener('click', function () {
      if(window.hsPushbar) {
        window.hsPushbar.open('left')
        window.hsPushbar.activeElement.innerHTML = filterHtml;
      }
      var filterForm = document.querySelector('.hs-collection__filters-form');
      if (filterForm) {
        var filterInputs = filterForm.querySelectorAll('input[type="checkbox"], input[type="number"]');
        filterInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            filterForm.submit();
          });
        });
      }
  });

  var sortForm = document.querySelector('.hs-collection__sort');
  if (sortForm) {
    var sortSelect = sortForm.querySelector('#sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortForm.submit();
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(max-width: 900px)');
    let accordionInstance = null;

    function handleAccordion(e) {
      if (e.matches) {
        // 屏幕 <= 900px 时，初始化手风琴
        if (!accordionInstance) {
          accordionInstance = accordion('.hs-footer__center-btn');
        }
      } else {
        // 屏幕 > 900px 时，销毁手风琴
        if (accordionInstance) {
          accordionInstance.destroy();
          accordionInstance = null;
        }
      }
    }

    // 初始执行一次
    handleAccordion(mediaQuery);

    // 监听屏幕尺寸变化
    mediaQuery.addEventListener('change', handleAccordion);

    // 监听屏幕尺寸变化
      mediaQuery.addEventListener('change', handleAccordion);
        if(window.hscycle) {
          const gotop = document.querySelector('.hs-gotop');
          function toggleGotop() {
            const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
            if (scrollPercent >= 5) {
              gotop.style.display = 'flex';
            } else {
              gotop.style.display = 'none';
            }
          }
          const throttledToggleGotop = window.hscycle.throttle(toggleGotop);
          window.addEventListener('scroll', throttledToggleGotop, { passive: true });
          gotop.addEventListener('click', function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h-banner"] && !Shopify.designMode) return;
  try {
    
const banner = document.querySelector(".hs-banner");
const progressCircle = banner;
const slidesCount = banner.querySelectorAll(".swiper-slide").length;
const isDesignMode = window.Shopify && window.Shopify.designMode;
const delay = 6000;

function polyfillAutoplayTimeLeft(swiper, delay, callback) {
  let raf = 0;
  let startAt = 0;
  const stop = () => {
    cancelAnimationFrame(raf);
    raf = 0;
  };
  const tick = (now) => {
    const timeLeft = Math.max(delay - (now - startAt), 0);
    const progress = timeLeft / delay; // 1 → 0，和 9+/14 一致
    callback(swiper, timeLeft, progress);
    if (timeLeft > 0) raf = requestAnimationFrame(tick);
  };
  const start = () => {
    stop();
    startAt = performance.now();
    raf = requestAnimationFrame(tick);
  };
  swiper.on("autoplayStart", start);
  swiper.on("slideChange", () => {
    if (swiper.autoplay.running) start();
  });
  swiper.on("autoplayStop", stop);
  if (swiper.autoplay?.running) start();
}

if (slidesCount > 1) {
  const swiper = new Swiper(".hs-banner", {
    slidesPerView: 1,
    loop: true,
    grabCursor: true,
    simulateTouch: true,
    pagination: {
      el: ".hs-banner__pgn",
      bulletClass: "hs-banner__pgn-item",
      clickable: true,
    },
    navigation: {
      nextEl: ".hs-banner__nav--next",
      prevEl: ".hs-banner__nav--prev",
    },
    autoplay: isDesignMode ? false : {
      delay,
      disableOnInteraction: false
    },
    on: {
      init(swiper) {
      if (isDesignMode) return;
        polyfillAutoplayTimeLeft(swiper, delay, (s, time, progress) => {
          progressCircle.style.setProperty("--progress", (1 - progress) * 100 + "%");
        });
      },
    }
  });
} else {
  banner.querySelectorAll(".hs-banner__nav, .hs-banner__pgn").forEach(function(el) {
    el.style.display = "none";
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    const tab = document.querySelector('.hs-header__menu-mega--tab')
    if(tab) {
      new A11yTabs(".hs-header__menu-mega--tab", '.hs-header__menu-mega-wrap [role="tabpanel"]', 0);
      const doms = document.querySelectorAll('.hs-header__menu-mega--tab button')
      // hover时自动切换超级菜单menu
      doms.forEach(element => {
        element.addEventListener('mouseenter', () => {
          document.dispatchEvent(new Event('super:menu:tab:click'));
          element.click();
        });
      });
    }




    // 初始化搜索推荐轮播产品卡片
    function initRecBottomSplide() {
      const splideEl = document.querySelector('.hs-ps__rec-btm-swp')
      if(!splideEl || !Swiper) return

      new Swiper(splideEl, {
        slidesPerView: 'auto',
        grabCursor: true,
        simulateTouch: true,
        navigation: {
          nextEl: '.hs-ps__rec-btm-nav[next]',
          prevEl: '.hs-ps__rec-btm-nav[prev]',
        }
      });

      const predRecEl = document.querySelector('.hs-ps__rec')
      // 监听“有值”事件
      document.addEventListener('pred-search-has-value', () => {
        predRecEl.style.display = 'none'
      });
      // 监听“无值”事件
      document.addEventListener('pred-search-is-empty', () => {
          predRecEl.style.display = 'block'
      });
    }

    

    const searchBtn = document.querySelector('.hs-header__widget-search')
    searchBtn.addEventListener('click', function() {
      if(window.hsPushbar) {
        var searchDom = document.querySelector('#hs-ps__tmp')
        var copySearchDom = searchDom.content.cloneNode(true)
        window.hsPushbar.open('top')
        window.hsPushbar.activeElement.innerHTML = searchDom.innerHTML
        initRecBottomSplide()
      }
    })

    
    const mMenuBtn = document.querySelector('.hs-header__widget-menu')
    mMenuBtn.addEventListener('click', function() {
      document.dispatchEvent(new CustomEvent('mmenu:click'))
    })

    const openCartBtn = document.querySelector('[data-side-cart-btn]');
    if (openCartBtn) {
      openCartBtn.addEventListener('click', () => {
        // 计算 cart 页面的标准路径
        const cartPath =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.cart_url) ||
          '/cart';

        // 去掉路径尾部多余的斜杠，避免 "/cart" 和 "/cart/" 不相等
        const normalizePath = (path) =>
          typeof path === 'string' ? path.replace(/\/+$/, '') : path;

        const currentPath = normalizePath(window.location.pathname);
        const targetCartPath = normalizePath(cartPath);

        // 如果当前就是购物车页面，则不打开抽屉，直接返回
        if (currentPath === targetCartPath) {
          window.location.href = cartPath;
          return;
        }

        if (!window.hscycle) return;

        document.dispatchEvent(new CustomEvent('hs:side:cart:click', { detail: { data: openCartBtn } }))
      });
    }


   // header滚动悬停效果
  const main = document.querySelector('.hs-main')
  const headerBox = document.querySelector('.hs-header');
  const topbar = document.querySelector('.hs-topbar');
  const mainMenu = document.querySelector('.hs-header__fixed');
  // 安全检查：如果关键元素不存在，直接退出，防止报错
  if (!headerBox || !topbar || !mainMenu) return;
  let lastScrollTop = 0;
  let triggerHeight = headerBox.offsetHeight * 3.5;
  let topThreshold = topbar.offsetHeight
  // 更新阈值函数
  const updateThresholds = () => {
      triggerHeight = headerBox.offsetHeight * 3.5;
      topThreshold = topbar.offsetHeight
  };
  window.addEventListener('resize', updateThresholds);
  document.addEventListener('header-height-changed', updateThresholds);
  // 使用 requestAnimationFrame 优化滚动性能，避免高频重绘
  let ticking = false;
  
  window.addEventListener('scroll', () => {
      if (!ticking) {
          window.requestAnimationFrame(() => {
              handleScroll();
              ticking = false;
          });
          ticking = true;
      }
  });
  function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      // 确定当前需要的状态类名
      let shouldHaveActive = false;
      let shouldHaveTop = false;
      // 逻辑分区
      if (currentScroll <= topThreshold) {
          // 区域 1: 顶部 (滚动距离 <= Topbar 高度)
          // 行为: 取消 fixed (恢复 relative), 显示在文档流中
          shouldHaveTop = true;
          shouldHaveActive = false; 
      } else if (currentScroll > triggerHeight) {
          // 区域 3: 深层滚动 (超过阈值)
          // 行为: 智能显示/隐藏 (Fixed 定位)
          shouldHaveTop = false;
          // 上滚显示，下滚隐藏
          if (currentScroll < lastScrollTop) {
              shouldHaveActive = true;
          } else {
              shouldHaveActive = false;
          }
      } else {
          // 区域 2: 中间过渡区 (Topbar 高度 < 滚动距离 <= 阈值)
          // 行为: 保持 Fixed 且显示，防止突然消失
          shouldHaveTop = false;
          shouldHaveActive = true;
      }
      
      if (shouldHaveActive) {
          mainMenu.classList.add('hs-header__fixed--active');
          main.classList.add('hs-hdfixed-mark')
      } else {
          mainMenu.classList.remove('hs-header__fixed--active');
          main.classList.remove('hs-hdfixed-mark')
      }
      if (shouldHaveTop) {
          mainMenu.classList.add('hs-header__fixed--top');
      } else {
          mainMenu.classList.remove('hs-header__fixed--top');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }
  // 初始化运行一次，防止页面加载时已有滚动条导致样式错误
  handleScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const root = document.querySelector('.hs-prod')
  const selectEl = root.querySelector('.hs-prod__buybar-var');
  const buybar = root.querySelector('.hs-prod__buybar');
  const footerEl = document.querySelector('.hs-footer')
  // buybar 显示隐藏功能
  const closeBuybar = root.querySelector('.hs-prod__buybar-close')
  const openBuybar = root.querySelector('.hs-prod__mbuybtn')
  if (!root) return;

  closeBuybar.addEventListener('click', function() {
    buybar.classList.remove('active');
  })
  openBuybar.addEventListener('click', function() {
    buybar.classList.add('active');
  })

  // 点击空白处关闭
  document.addEventListener('click', function(e) {
    if (window.innerWidth >= 900) return
    // buybar 未打开 → 不处理
    if (!buybar.classList.contains('active')) return;

    // 如果点击在 buybar 内部 → 不关闭
    if (buybar.contains(e.target)) return;

    if (openBuybar.contains(e.target)) return;

    // 点击在 buybar 外部 → 关闭
    buybar.classList.remove('active');
  });

  // 滚动监听，控制 buybar btn 显示隐藏
  if (openBuybar && root) {
    const obsBuyBar = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 在视口内 → 移除 active
          openBuybar.classList.remove('active');
          footerEl.classList.remove('prod-active')
        } else {
          // 离开视口 → 添加 active
          openBuybar.classList.add('active');
          footerEl.classList.add('prod-active')
        }
      });
    }, {
      threshold: 0, // 只要离开一点点视口就触发
    });
    obsBuyBar.observe(root);
  }
  
  if (root && buybar) {
    let observer = null;

    function enableObserver() {
      if (observer) return; // 已经启用过了
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            buybar.classList.remove('active');
            footerEl.classList.remove('prod-active')
          } else {
            buybar.classList.add('active');
            footerEl.classList.add('prod-active')
          }
        });
      }, {
        threshold: 0
      });
      observer.observe(root);
    }

    function disableObserver() {
      if (!observer) return; // 已经禁用了
      observer.disconnect();
      observer = null;
    }

    function handleResize() {
      if (window.innerWidth >= 900) {
        enableObserver();
      } else {
        disableObserver();
      }
    }
    // 初始执行
    handleResize();
    // 监听屏幕变化
    window.addEventListener('resize', handleResize);
  }


// 购物逻辑 -------------------------------------------------------
document.dispatchEvent(new CustomEvent('hs:prod:shopping:init', {
    detail: {
        root
    }
}))

// buybar变体切换
if (selectEl) {
  selectEl.addEventListener('change', e => {
    document.dispatchEvent(new CustomEvent('hs:prod:var:id:change', {
        detail: {
            selectedData: e.target.value,
            root, 
        }
    }))
  })
}

// ------------------------------------------------------------
// 设置购买栏选择的变体
function setBarSelectedVariant(selectedVariant, selectEl) {
    if(selectedVariant && selectEl) {
        selectEl.value = selectedVariant.id
    }
}


// 监听变体切换事件
document.addEventListener('hs:prod:var:changed', function(data) {
    if (data && data.detail) {
        const root = data.detail.root || null
        if(!root.classList.contains('hs-prod')) return
        const selectedVariant = data.detail.selectedVariant || null
        if(!selectedVariant || !root) return
        setBarSelectedVariant(selectedVariant, selectEl) // 设置购买栏选择的变体
        // 1) 更新 URL 里的 ?variant=ID（不会刷新页面）
        let url = new URL(window.location.href);
        url.searchParams.set('variant', String(selectedVariant.id));
        window.history.replaceState({}, '', url.toString());
    }
})

    // 放大镜效果
    function magnify(imgDom, zoom) {
      var img, glass, w, h, bw;
      img = imgDom
      glass = document.createElement("DIV");
      glass.setAttribute("class", "hs-prod__cover--glass");
      img.parentElement.insertBefore(glass, img);

      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";

      bw = 0;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
    
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);

      function moveMagnifier(e) {
        var pos, x, y;
        e.preventDefault();
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        const outOfBounds =
            x > img.width - (w / zoom) ||
            x < w / zoom ||
            y > img.height - (h / zoom) ||
            y < h / zoom;
        if (outOfBounds) {
            glass.style.opacity = 0;
            return;
        } else {
            glass.style.opacity = 1;
        }
        glass.style.left = (x - w) + "px";
        glass.style.top = (y - h) + "px";
        glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
      }
    
      function getCursorPos(e) {
        var a, x = 0, y = 0;
        e = e || window.event;
        a = img.getBoundingClientRect();
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x : x, y : y};
      }
    }
    const prodCoverImgs = document.querySelectorAll('.hs-pimg__main-img')

    if (window.innerWidth > 900) {
        prodCoverImgs.forEach(img => {
            magnify(img, 2.5);
        })
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-nav-ss"] && !Shopify.designMode) return;
  try {
    
  if (!window.hscycle || !Swiper) return;

  const swiper = new Swiper(document.querySelector('.hs-tab__swp'), {
      slidesPerView: 'auto',
      spaceBetween: 0,
      simulateTouch: true,
      grabCursor: true,
      slideToClickedSlide: true,
  });


  const tabSection = document.querySelector('.hs-tab');
  const tabWrap = document.querySelector('.hs-tab__wrap');
  const headerHeight = document.querySelector('.hs-header__fixed')

  // 1. 吸顶逻辑（保持不变，只是封装了一下）
  if (tabSection && tabWrap && headerHeight) {
    let sectionTop = tabSection.offsetTop - headerHeight.offsetHeight;

    function handleSticky() {
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY >= sectionTop) {
        tabWrap.classList.add('active');
      } else {
        tabWrap.classList.remove('active');
      }
    }

    const throttledSticky = window.hscycle.throttle(handleSticky, 50);
    window.addEventListener('scroll', throttledSticky);
    window.addEventListener('resize', window.hscycle.throttle(() => {
      sectionTop = tabSection.offsetTop;
      handleSticky();
    }, 500));

    throttledSticky();
  }

  // 2. 动态 Tab 激活逻辑（完全不写死 ID）
  const btnActiveName = 'active';
  const tabButtons = Array.from(document.querySelectorAll('.hs-tab__btn[hs-tab-target]'));

  let sections = [];

  function computeSections() {
    sections = [];

    tabButtons.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      const id = href.slice(1);
      if (!id) return;

      const targetEl = document.getElementById(id);

      // 如果目标 section 不存在，隐藏对应的 li
      if (!targetEl) {
        const parentLi = btn.closest('.hs-tab__item');
        if (parentLi) parentLi.style.display = 'none';
        return;
      }

      // 确保存在时显示
      const parentLi = btn.closest('.hs-tab__item');
      if (parentLi) parentLi.style.display = '';

      sections.push({
        btn: btn,
        el: targetEl,
        start: targetEl.offsetTop
      });
    });

    // 按页面顺序排序
    sections.sort((a, b) => a.start - b.start);

    // 生成区间 [start, end)
    for (let i = 0; i < sections.length; i++) {
      const current = sections[i];
      const next = sections[i + 1];
      current.start = current.el.offsetTop;
      current.end = next ? next.el.offsetTop : Infinity;
    }
  }

  computeSections();

  window.addEventListener('resize', window.hscycle.throttle(() => {
    computeSections();
    tabHandleScroll();
  }, 500));

  function tabHandleScroll() {
    const scrollY = (window.scrollY || window.pageYOffset) + 60;

    tabButtons.forEach((btn) => btn.classList.remove(btnActiveName));

    const current = sections.find((item) => scrollY >= item.start && scrollY < item.end);
    if (current && current.btn) {
      current.btn.classList.add(btnActiveName);
      swiper.slideTo(current.btn.dataset.slide);
    }
  }

  const throttledTabScroll = window.hscycle.throttle(tabHandleScroll, 300);
  window.addEventListener('scroll', throttledTabScroll);
  throttledTabScroll();

  // 3. 监听 section 高度变化，动态更新区间
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      computeSections();
      tabHandleScroll();
    });

    tabButtons.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      const id = href.slice(1);
      if (!id) return;

      const targetEl = document.getElementById(id);
      if (targetEl) ro.observe(targetEl);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.hs-lazy-video');
    const screenWidth = window.innerWidth;
    // 根据屏幕宽度选择视频源
    function getVideoSrc(sourceEl) {
        if (screenWidth > 900) {
            return sourceEl.dataset.pcSrc;
        } else {
            return sourceEl.dataset.mSrc || sourceEl.dataset.pcSrc;
        }
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;
                const source = video.querySelector('source');
                const ctr = video.closest('.hs-vdobn__wrap');
                const coverImg = ctr?.querySelector('.hs-vdobn__cover');
                // 选择正确的视频源
                const selectedSrc = getVideoSrc(source);
                // 懒加载：只有进入视口才设置 src
                if (selectedSrc && source.src !== selectedSrc) {
                    source.src = selectedSrc;
                    video.load();
                }
                video.play().catch(() => {});
                video.addEventListener('loadeddata', () => {
                    if (coverImg) coverImg.style.opacity = '0';
                });
                observer.unobserve(video);
            }
        });
    }, {
        rootMargin: '200px 0px',
        threshold: 0.1
    });
    videos.forEach(video => observer.observe(video));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newslatter"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  function setHideTime(days) {
    const expireAt = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem('hs_newsletter_hide_until', expireAt);
  }

  function isHidden() {
    const until = localStorage.getItem('hs_newsletter_hide_until');
    return until && Number(until) > Date.now();
  }

  const popup = document.querySelector('.hs-nlpoup');
  if (!popup) return;

  const delay = Number(popup.dataset.delay) || 0;
  const cookieDays = Number(popup.dataset.cookieDays) || 30;

  const url = window.location.href;
  const justSubscribed = url.includes('customer_posted=true') && url.includes('#hs-nlpoup-form');
  const img = popup.querySelector('.hs-nlpoup__img')
  const realImgSrc = img ? img.dataset.src : null;

  function loadImage() {
    if (!img || !realImgSrc) return;
    // 如果已经加载过，直接返回
    if (img.src === realImgSrc) return;
    img.src = realImgSrc;
  }

  // 刚订阅成功，立即打开，不延时
  if (justSubscribed && !isHidden()) {
    popup.style.display = 'flex';
    popup.classList.add('show');
    loadImage();
  } else {
    // 正常逻辑
    if (!isHidden()) {
      document.addEventListener('scroll', () => {
        if (window.scrollY > 1) {
          setTimeout(() => {
            popup.style.display = 'flex';
            popup.classList.add('show');
            loadImage();
          }, delay);
        }
      },{ once: true });
    }
  }

  const hideCheckbox = popup.querySelector('#nlpoup-input');

  const closePopup = () => {
    popup.classList.remove('show');
    setTimeout(() => {
      popup.style.display = 'none';
    }, 300);
    if (hideCheckbox && hideCheckbox.checked) {
      setHideTime(cookieDays);
    }
  };

  const closeButton = popup.querySelector('.hs-nlpoup__close');
  const overlay = popup.querySelector('.hs-nlpoup__overlay');

  if (closeButton) closeButton.onclick = closePopup;
  if (overlay) overlay.onclick = closePopup;

  const form = popup.querySelector('.hs-nlpoup__form');
  form.addEventListener('submit', async (e) => {
    // 不要立即关闭弹窗
    // setHideTime(cookieDays);
  });
});

  } catch(e) { console.error(e); }
})();
})();
